<div class="background-background-blue position-relative body-screen border-box overflow-hidden" data-test-id="templates">
  <div class="filters-bar border--bottom-border-gray flex align-items-center justify-content-between">
    <div class="flex align-items-center margin-xxl--left-32">
      <div
        (click)="activeTab = 'Cargo'"
        [ngClass]="{
          'color-sky-blue background-white font-bold': activeTab === 'Cargo',
          'color-body-text background-background-blue-dark': activeTab !== 'Cargo'
        }"
        style="transition: color 0.3s ease-in-out"
        class="filter-button font--xxl-13 color-body-text background-background-blue-dark font-regular align-items-center border--right-white cursor-pointer"
      >
        Cargo
      </div>
      <div
        *ngIf="hasPermissionToSeeClients"
        (click)="activeTab = 'Clients'"
        [ngClass]="{
          'color-sky-blue background-white font-bold': activeTab === 'Clients',
          'color-body-text background-background-blue-dark': activeTab !== 'Clients'
        }"
        style="transition: color 0.3s ease-in-out"
        class="filter-button font--xxl-13 color-body-text background-background-blue-dark font-regular align-items-center border--right-white cursor-pointer"
      >
        Clients
      </div>
      <div
        (click)="activeTab = 'ClientLocations'"
        [ngClass]="{
          'color-sky-blue background-white font-bold': activeTab === 'ClientLocations',
          'color-body-text background-background-blue-dark': activeTab !== 'ClientLocations'
        }"
        style="transition: color 0.3s ease-in-out"
        class="filter-button font--xxl-13 color-body-text background-background-blue-dark font-regular align-items-center border--right-white cursor-pointer"
      >
        {{ hasPermissionToSeeClients ? 'Ship To' : 'Locations' }}
      </div>
      <div
        *ngIf="hasPermissionToSeeClients"
        (click)="activeTab = 'InnerLocations'"
        [ngClass]="{
          'color-sky-blue background-white font-bold': activeTab === 'InnerLocations',
          'color-body-text background-background-blue-dark': activeTab !== 'InnerLocations'
        }"
        style="transition: color 0.3s ease-in-out"
        class="filter-button font--xxl-13 color-body-text background-background-blue-dark font-regular align-items-center cursor-pointer"
      >
        Ship From
      </div>
    </div>
    <div *ngIf="!isLoading" class="flex align-items-center">
      <div class="flex h-100 align-items-center margin-xxl--right-12 job-status-filter">
        <app-clients-search
          *ngIf="activeTab === 'ClientLocations'"
          [keyProperty]="'id'"
          [valueProperty]="'name'"
          [isSingleSelect]="true"
          [selectedItems]="selectedClient"
          (selectedItemsChanged)="filterLocationsByClient($event)"
        ></app-clients-search>
      </div>
      <div class="flex h-100 align-items-center margin-xxl--right-12 job-status-filter">
        <app-dropdown
          *ngIf="activeTab === 'ClientLocations' || activeTab === 'InnerLocations'"
          [icon]="'arrow'"
          [selectedItem]="selectedCountry"
          (selectedItemChange)="filterLocationsByCountry($event)"
          [items]="countries"
          [placeholder]="'Country: All'"
          [dropDownType]="dropDownTypeEnum.box"
        ></app-dropdown>
      </div>
      <div
        *ngIf="haveUsedFilters() && (activeTab === 'ClientLocations' || activeTab === 'InnerLocations')"
        class="font--xxl-13 font-regular cursor-pointer color-body-text margin-xxl--left-16 margin-xxl--right-32"
        (click)="clearFilters()"
      >
        Clear all
      </div>
    </div>
    <div class="flex align-items-center">
      <div class="flex align-items-center padding-xxl--right-18 h-100">
        <input
          *ngIf="activeTab === 'ClientLocations' || activeTab === 'InnerLocations'"
          id="search"
          class="input-search input-border border-white font--xxl-13 color-dark-blue"
          placeholder="Location Name"
          type="text"
          appDebounce
          [(ngModel)]="currentFilter.search"
          (emitter)="onLocationSearch($event)"
          [inputVal]="currentFilter.search"
        />
        <input
          *ngIf="activeTab === 'Clients'"
          id="search"
          class="input-search input-border border-white font--xxl-13 color-dark-blue"
          placeholder="Client name"
          type="text"
          appDebounce
          [inputVal]="clientSearch"
          [(ngModel)]="clientSearch"
          (emitter)="searchClients()"
        />
      </div>
      <button
        class="button-round-small color-dark-blue border-z-green font--xxl-12 font-bold background-turquoise--dark margin-xxl--top-24 margin-xxl--bottom-24 margin-xxl--right-32"
        (click)="openPopups()"
      >
        + Add new
      </button>
    </div>
  </div>
  <div class="body background-white position-relative">
    <!-- Cargo -->
    <div *ngIf="activeTab === 'Cargo'" class="h-100">
      <app-cargo-tab (editLoad)="editData($event)"></app-cargo-tab>
    </div>
    <!-- Clients -->
    <div *ngIf="activeTab === 'Clients'" class="h-100">
      <app-clients-tab (editClient)="editData($event)" [clients]="clients"></app-clients-tab>
    </div>
    <!-- ShipTo -->
    <div *ngIf="activeTab === 'ClientLocations'" class="h-100">
      <app-shipping-locations
        [activeTab]="activeTab"
        [filter]="currentFilter"
        (editLocation)="editData($event)"
        [hasPermissionToSeeClients]="hasPermissionToSeeClients"
      >
      </app-shipping-locations>
    </div>
    <!-- ShipFrom -->
    <div *ngIf="activeTab === 'InnerLocations'" class="h-100">
      <app-shipping-locations
        [activeTab]="activeTab"
        [filter]="currentFilter"
        [hasPermissionToSeeClients]="hasPermissionToSeeClients"
        (editLocation)="editData($event)"
        (locationDetails)="openLocationDetails($event)"
      >
      </app-shipping-locations>
    </div>
  </div>
  <app-add-new
    *ngIf="openPopup"
    [data]="data"
    [activeTab]="activeTab"
    (triggerEmitter)="stopTrigger($event)"
  ></app-add-new>
  <app-loader class="loader w-100 h-100" *ngIf="isLoading"> </app-loader>
</div>
